import { axiosBasic } from "../config/axios-common";


const getStatusProtocol = (protocol: string) => {
    return axiosBasic.get(`/sam/v1/request/getProtocol/${protocol}`).then(response => {
        return response.data
    })
      .catch(e => {
         console.log(e)
      })
}

const exportedObject = {
    getStatusProtocol,
};
  
  
export default exportedObject
  